import type { CreatePackageTemplateDTO } from "@/modules/packages/domain/contracts";

/**
 * Mock data สำหรับ dev mode auto fill
 * ข้อมูลจริงที่เตรียมไว้ 5 ชุดสำหรับ Package Template
 */

export const mockPackageTemplates: Omit<CreatePackageTemplateDTO, "rules">[] = [
  {
    name: "ແພັກເກດ 10 ຄັ້ງ",
    totalSessions: 10,
    validDays: 60,
    price: 500000,
    description: "ແພັກເກດພື້ນຖານ ສຳລັບນັກຮຽນເລີ່ມຕົ້ນ",
    status: "active",
  },
  {
    name: "ແພັກເກດ 20 ຄັ້ງ",
    totalSessions: 20,
    validDays: 90,
    price: 900000,
    description: "ແພັກເກດປານກາງ ສຳລັບນັກຮຽນທົ່ວໄປ",
    status: "active",
  },
  {
    name: "ແພັກເກດ 30 ຄັ້ງ",
    totalSessions: 30,
    validDays: 120,
    price: 1200000,
    description: "ແພັກເກດໃຫຍ່ ສຳລັບນັກຮຽນທີ່ມັກເຂົ້າຄລາດສ໌",
    status: "active",
  },
  {
    name: "ແພັກເກດ 50 ຄັ້ງ",
    totalSessions: 50,
    validDays: 180,
    price: 2000000,
    description: "ແພັກເກດພິເສດ ສຳລັບນັກຮຽນທີ່ມັກເຂົ້າຄລາດສ໌ຫຼາຍ",
    status: "active",
  },
  {
    name: "ແພັກເກດ 100 ຄັ້ງ",
    totalSessions: 100,
    validDays: 365,
    price: 3500000,
    description: "ແພັກເກດປີ ສຳລັບນັກຮຽນທີ່ມັກເຂົ້າຄລາດສ໌ປະຈຳ",
    status: "active",
  },
];

/**
 * ฟังก์ชันสุ่มข้อมูลจาก array
 */
export function getRandomMockData<T>(data: T[]): T {
  const randomIndex = Math.floor(Math.random() * data.length);
  return data[randomIndex]!;
}
